/**
 * 能力项编辑
 * @author 3173
 * @date 2020-07-18
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import { Divider } from 'antd'
import { framework_tool, component_tool, utils_tool } from '@/tool'
let { WizContainer, modelUtils } = framework_tool;
let { WizCol, WizRow, WizButton, WizModal, WizList, WizTable, WizDataTable } = component_tool;
const { Oper } = WizDataTable;
import AbilityItemForm from './abilityItemForm';


class AbilityItemEditList extends WizContainer {

  componentName = 'abilityItemEditList';

  static propTypes = {
    value: PropTypes.array,
    onChange: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value, //[{"key":1,"id":1,"name":"1","state":1},{"key":2,"id":2,"name":"2","state":0}],
      visible: false,

    };
    this.deleteKey;
  }

  _componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({ value: nextProps.value });
    }
  }

  /**
   * 监控选择modal的返回值，并且将值反馈给Form
   */
  triggerChange = (nextTargetKeys) => {
    const { onChange } = this.props;
    this.setState({
      value: nextTargetKeys,
      date: new Date().getTime()
    });
    if (onChange) {
      onChange(nextTargetKeys);
    }
  };

  /**
   * 打开modal
   */
  changeVisible(visible) {
    this.setState({
      visible: visible,
      item: undefined,
      date: new Date().getTime()
    });
  };

  /**
   * 确定按钮
   */
  onSubmit = () => {
    const { onChange } = this.props;
    const { value } = this.state;
    this.setState({
      visible: false
    });
    if (onChange) {
      onChange(value);
    }
  };


  editRecord(record) {
    this.setState({
      visible: true,
      item: record,
      date: new Date().getTime()
    });
  }



  /** 行删除 */
  deleteRecord(record) {
    let { value } = this.state;
    let neoValue = [];
    if (record.id) {
      let content = "确认删除能力项'" + record.name + "'吗？"
      WizModal.confirm({
        title: '注意', content,
        onOk: () => {
          this.deleteKey = record.key
          this.doAction({
            path: 'abilityItem/delete',
            payload: {
              key: 'abilityItemDelete',
              apiParams: {
                ids: [record.id],
              }
            }
          });
        },
        onCancel() {
        }
      });
    } else {
      for (let i = 0; i < value.length; i++) {
        if (value[i].key !== record.key) {
          neoValue.push(value[i])
        }
      }

      this.setValue(neoValue);
    }
  }

  propsAndStateOnChange = {
    abilityItemDelete: this.abilityItemDeleteOver.bind(this),
  };

  /**
   * 修改状态返回结果
   * @param nextProps
   * @param nextState
   */
  abilityItemDeleteOver(nextProps, nextState) {
    const { onChange } = this.props;
    if (nextProps.abilityItemDelete.code == 1) {
      let { value } = this.state;
      let neoValue = Object.assign([]);
      for (let i = 0; i < value.length; i++) {
        if (value[i].key !== this.deleteKey) {
          neoValue.push(value[i])
        }
      }
      nextState.value = neoValue;
      nextState.date = new Date().getTime();
      if (onChange) {
        onChange(neoValue);
      }
      wizNotice.success('删除成功');
      return true;
    } else {
      wizNotice.error('删除失败：' + nextProps.abilityItemDelete.msg);
    }
  }

  /** 改变行属性 */
  changeRecord(record) {
    let { value } = this.state;
    let neoValue = Object.assign([], value);
    if (record.state == 1) {
      let content = "能力项禁用后，学员查看页面将不再展示该能力项评分，确认禁用吗?"
      WizModal.confirm({
        title: '注意', content,
        onOk: () => {
          neoValue.forEach((value, index) => {
            if (value.key === record.key) {
              value.state = (value.state === 1 ? 0 : 1);
            }
          });
          this.setValue(neoValue);
        },
        onCancel() {
        }
      });
    } else {
      neoValue.forEach((value, index) => {
        if (value.key === record.key) {
          value.state = (value.state === 1 ? 0 : 1);
        }
      });
      this.setValue(neoValue);
    }
  }

  /**更新state并返回值给form */
  setValue(value) {
    const { onChange } = this.props;
    this.setState(
      { value: value, visible: false, date: new Date().getTime() },
      () => {
        if (onChange) {
          onChange(value);
        }
      }
    )
  }


  /**
   * 渲染列表
   */
  _renderList() {
    const { placeholder, ...otherProps } = this.props;

    const columns = [
      {
        title: '能力项名称',
        dataIndex: 'name',
        key: 'name',
        width: 80
      },
      {
        title: '状态',
        dataIndex: 'state',
        key: 'state',
        dict: [
          { code: 1, codeName: '有效' },
          { code: 0, codeName: '无效' }
        ],
        width: 50,
        render: (text, record) => (
          <>{record.state == 1 ? "有" : "无"}效</>
        ),
      },
      {
        title: '是否展示',
        dataIndex: 'exhibition',
        key: 'exhibition',
        dict: [
          { code: 1, codeName: '是' },
          { code: 0, codeName: '否' }
        ],
        width: 50,
        render: (text, record) => (
          <>{record.exhibition == 1 ? "是" : "否"}</>
        ),
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 80,
        render: (text, record) => (
          <span>
            <a onClick={e => this.editRecord(record)}> 编辑 </a>
            <Divider type="vertical" />
            <a onClick={e => this.changeRecord(record)}> {record.state == 1 ? '禁' : '启'}用</a>
            <Divider type="vertical" />
            <a onClick={e => this.deleteRecord(record)} key={record.key + "delete"} >删除</a>
          </span>
        ),
      },
    ]

    return (
      <WizTable pagination={false} columns={columns} dataSource={this.state.value} />
    )

  }

  /** 新增能力项数据处理 */
  addAbilityItem(item) {
    let { value } = this.state;
    let neoValue = Object.assign([], value);
    //去除同名能力项名称
    let doubleName = value.map((v) => {
      return v['name'] === item['name'] ? v : undefined
    }).filter(Boolean);
    if (doubleName && doubleName.length) {
      wizNotice.warn(`能力项名称 ${doubleName[0]['name']} 已存在,请重新添加`)
    } else {
      if (item && item.update) {
        if (item.tips) {
          let content = "能力项禁用后，学员查看页面将不再展示该能力项评分，确认禁用吗?"
          WizModal.confirm({
            title: '注意', content,
            onOk: () => {
              neoValue.forEach((data, index) => {
                if (data.key === item.key) {
                  data.state = item.state;
                  data.name = item.name;
                  data.exhibition = item.exhibition;
                }
              });
              this.setValue(neoValue);
            },
            onCancel() {
            }
          });
        } else {
          neoValue.forEach((data, index) => {
            if (data.key === item.key) {
              data.state = item.state;
              data.name = item.name;
              data.exhibition = item.exhibition;
            }
          });
        }
      } else {
        neoValue.push(item);
      }
      this.setValue(neoValue);
    }
  }


  /**
   * 渲染modal框内的内容
   */
  _renderSelect() {
    return <AbilityItemForm key={'editListForm' + new Date().getTime()} abilityItemData={this.state.value} addAbilityItem={this.addAbilityItem.bind(this)} item={this.state.item} />
  }

  _render() {
    const { modal, placeholder, ...otherProps } = this.props;
    return (
      <>
        {this._renderList()}

        <WizModal
          className="antui-transfer-modal"
          title={'添加' + otherProps.title}
          visible={this.state && this.state.visible}
          width={600}
          footer={null}
          {...modal}
          onCancel={() => this.changeVisible(false)}
          maskClosable
        >
          {this._renderSelect()}
        </WizModal>
        <WizButton type="primary" onClick={() => this.changeVisible(true)}>添加</WizButton>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { abilityItem } = state;
  const abilityItemDelete = modelUtils.getModelEntity(abilityItem, "abilityItemDelete");
  const load = modelUtils.getLoadingState(state, ['abilityItem']);
  return {
    abilityItemDelete: abilityItemDelete,
    ...load
  }
};

export default connect(mapStateToProps)(AbilityItemEditList);
